import request from '../utils/request'

const url = '/vehicle-relation'

/**
 * 分页查询车辆关系
 * @param params 查询参数
 * @param data 查询条件
 * @returns {AxiosPromise}
 */
export const getList = (params, data) => {
  return request({
    url: url + '/page',
    method: 'post',
    params,
    data
  })
}

/**
 * 添加车辆关系
 * @param data
 * @returns {AxiosPromise}
 */
export const add = (data) => {
  return request({
    url: url,
    method: 'post',
    data
  })
}

/**
 * 修改车辆关系
 * @param data
 * @returns {AxiosPromise}
 */
export const edit = (data) => {
  return request({
    url: url,
    method: 'put',
    data
  })
}

/**
 * 删除车辆关系
 * @param id
 * @returns {AxiosPromise}
 */
export const deleteOne = (id) => {
  return request({
    url: url + '/' + id,
    method: 'delete'
  })
}

/**
 * 批量删除车辆关系
 * @param ids
 * @returns {AxiosPromise}
 */
export const deleteBatch = (ids) => {
  return request({
    url: url + '/batch/' + ids,
    method: 'delete'
  })
}

/**
 * 根据ID查询车辆关系
 * @param id
 * @returns {AxiosPromise}
 */
export const getOne = (id) => {
  return request({
    url: url + '/' + id
  })
}

/**
 * 提交车辆关系修改
 * @param data
 * @returns {AxiosPromise}
 */
export const submitRelations = (data) => {
  return request({
    url: url + '/submit',
    method: 'post',
    data
  })
}

/**
 * 根据班次查询车辆关系
 * @param shiftType
 * @returns {AxiosPromise}
 */
export const getByShiftType = (shiftType) => {
  return request({
    url: url + '/shift/' + shiftType
  })
}